<div class="quick-view">
  <button type="button" class="close-btn" (click)="activeModal.dismiss()" aria-label="Close">
    <i class="fas fa-times"></i>
  </button>

  <div class="quick-view-banner">
    <img [src]="bannerImage" [alt]="shop.name" />
    <span class="status-pill" [class.open]="isOpen">{{ isOpen ? 'Open' : 'Closed' }}</span>

    <div class="quick-view-logo-wrapper">
      <img class="quick-view-logo" [src]="logoImage" [alt]="shop.name + ' logo'" />
    </div>
  </div>

  <div class="quick-view-body">
    <div class="quick-view-title-row">
      <h3>{{ shop.name }}</h3>
      <span class="rating" *ngIf="shop.rating">
        <i class="fas fa-star"></i> {{ shop.rating | number:'1.1-1' }}
        <small *ngIf="shop.review_count">({{ shop.review_count }})</small>
      </span>
    </div>

    <p class="category" *ngIf="shop.categories?.length">{{ shop.categories[0].name }}</p>
    <p class="category" *ngIf="!shop.categories?.length && shop.category_name">{{ shop.category_name.split(',')[0].trim() }}</p>
    <p class="tagline" *ngIf="shop.tagline">{{ shop.tagline }}</p>

    <div class="info-row" *ngIf="shop.address">
      <i class="fas fa-map-marker-alt"></i> {{ shop.address }}
    </div>

    <div class="info-row" *ngIf="todayHours as hours">
      <i class="fas fa-clock"></i>
      {{ hours.is_open ? (hours.opening_time + ' - ' + hours.closing_time) : 'Closed today' }}
    </div>

    <div class="info-row" *ngIf="shop.delivery_time_min">
      <i class="fas fa-motorcycle"></i> {{ shop.delivery_time_min }}-{{ shop.delivery_time_max || shop.delivery_time_min }} min delivery
    </div>

    <a class="btn-visit-shop" [routerLink]="['/shop', shop.slug]" (click)="activeModal.close()">
      Visit Shop <i class="fas fa-arrow-right"></i>
    </a>
  </div>
</div>
